
import { Icon } from '@fasstech/middle-design-system';

const DemographyInformation = ({ label, value }) => {
  return (
    <div className="flex flex-row w-full gap-2 ">
      <span className="font-semibold">{label}</span>
      <span>{value}</span>
    </div>
  );
};

export const DemographyInformations = ({ demography, getMiddleBoolean }) => {
  return (
    <div className="flex flex-col border p-4 rounded w-fit  min-w-3/8">
      <div className="flex flex-col items-center w-full p-2">
        <Icon
          name={'circleDemography'}
          fillCassName="fill-primary"
          size="48"
        ></Icon>
        <h5 className="font-bold">Demographie</h5>
      </div>
      <div className="grid grid-cols-2 grid-rows-2 gap-4">
        <DemographyInformation
          value={demography.category}
          label="Catégorie du personnel"
        />
        {getMiddleBoolean('ENTREPRISE_DEMOGRAPHIE_NB_SALARIES_EST_NECESSAIRE') &&
          <DemographyInformation
            value={demography.employeeCount}
            label="Nombre de salariés"
          />
        }
        {getMiddleBoolean('ENTREPRISE_DEMOGRAPHIE_AGE_MOYEN_SALARIE_EST_NECESSAIRE') &&
          <DemographyInformation
            value={demography.averageAge}
            label="Age moyen des salariés"
          />
        }
        {getMiddleBoolean('ENTREPRISE_DEMOGRAPHIE_NB_CONJOINTS_EST_NECESSAIRE') &&
          <DemographyInformation
            value={demography.partnerCount}
            label="Nombre de conjoints"
          />
        }
        {getMiddleBoolean('ENTREPRISE_DEMOGRAPHIE_NB_ENFANTS_EST_NECESSAIRE') &&
          <DemographyInformation
            value={demography.childrenCount}
            label="Nombre d'enfants"
          />
        }
        {getMiddleBoolean('ENTREPRISE_DEMOGRAPHIE_REGIME_EST_NECESSAIRE') &&
          <DemographyInformation
            value={demography.customerSocialSecurityRegime}
            label="Régime"
          />
        }
      </div>
    </div>
  );
};
